import { NotifiableByMailOrder } from './has-id.interface';
import { UpdatePlannedAccesOrder } from './update-planned-acces-order.entity';

export class UpdateAndDenyAccesOrder extends UpdatePlannedAccesOrder implements NotifiableByMailOrder {
	motifRefus!: number;
	
	forceMailsAsTest?: boolean;

	constructor() {
		super();
	}
}